import React from "react";
import style from "./footer.module.scss";

function FooterComponent({ items }) {
  return (
    <div className={style.container}>
        <p>Copyright © 2022 <span>Leandro Federico Angel</span>, todos los derechos reservados.</p>
    </div>
  );
}

export default FooterComponent;
